/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This tool compares whole lines. A line that changed shows as one removed line plus one added line.`)
};

const es_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta herramienta compara líneas completas. Una línea que cambió aparece como una línea eliminada más una línea agregada.`)
};

const de_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Tool vergleicht ganze Zeilen. Eine geänderte Zeile wird als eine entfernte Zeile plus eine hinzugefügte Zeile angezeigt.`)
};

const nl_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit gereedschap vergelijkt hele regels. Een regel die is veranderd, wordt weergegeven als één verwijderde regel plus één toegevoegde regel.`)
};

const fr_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet outil compare des lignes entières. Une ligne qui a changé s'affiche comme une ligne supprimée plus une ligne ajoutée.`)
};

const it_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo strumento confronta intere righe. Una riga che è cambiata viene visualizzata come una riga rimossa più una riga aggiunta.`)
};

const pt_br2_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta compara linhas inteiras. Uma linha que mudou aparece como uma linha removida mais uma linha adicionada.`)
};

const pt_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta compara linhas inteiras. Uma linha que mudou aparece como uma linha removida mais uma linha adicionada.`)
};

const ja_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このツールは行全体を比較します。変更された行は1つの削除された行と1つの追加された行として表示されます。`)
};

const zh_td_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此工具以整行为单位进行比较。发生变化的一行会显示为一行删除加一行新增。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_faq3_a", locale)
	if (locale === "en") return en_td_faq3_a(inputs)
	if (locale === "es") return es_td_faq3_a(inputs)
	if (locale === "de") return de_td_faq3_a(inputs)
	if (locale === "nl") return nl_td_faq3_a(inputs)
	if (locale === "fr") return fr_td_faq3_a(inputs)
	if (locale === "it") return it_td_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_td_faq3_a(inputs)
	if (locale === "pt") return pt_td_faq3_a(inputs)
	if (locale === "ja") return ja_td_faq3_a(inputs)
	return zh_td_faq3_a(inputs)
};